import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import { actualizarDatosParaMuiTable, obtenerMovimientosDeMercaderia } from '../actions/TablaMovimientosMercaderiaActions'
import { TablaMovimientosMercaderiaView } from '../components/TablaMovimientosMercaderiaView'
import FormMovimientosMercaderia from '../components/FormMovimientosMercaderia'

class TablaMovimientosMercaderia extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  handleSubmit () {
    this.props.obtenerMovimientosDeMercaderia()
  }

  render () {
    return (
      <div>
        <h3>Movimientos de Mercadería</h3>
        <hr />
        <FormMovimientosMercaderia onSubmit={this.handleSubmit} onChange={this.onChangeDate} />
        <hr />
        <TablaMovimientosMercaderiaView total={this.props.total} />
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    total: state.movimientosMercaderia.total
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable, obtenerMovimientosDeMercaderia
}
const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(
  TablaMovimientosMercaderia)
